import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-12fbf16a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-message-template" }
const _hoisted_2 = { class: "cm-message-header" }

import { computed, PropType } from 'vue'
import { i18n } from '@/i18n'
import {
  Content,
  ApprovalPath,
} from '@/views/_components/message-template/approval-remind/approval-remind.service'
import { router } from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'approval-remind',
  props: {
  content: {
    type: Object as PropType<Content>,
    default: () => ({} as any)
  },
  notificationKey: {
    type: String,
  }
},
  emits: ['closeDetails'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const props = __props

const t = i18n.global.t.bind(i18n.global)

const approvalTypeLabel = computed(() =>
  t(`messageTemplate.approvalRemind.approvalType.${props.content.approval_type}`)
)

const applicationLabel = computed(() =>
  t('messageTemplate.approvalRemind.application', { type: approvalTypeLabel.value })
)

const menuName = computed(() =>
  t(`messageTemplate.approvalRemind.approvalMenu.${props.content.approval_type}`)
)

const headerText = computed(() =>
  t('messageTemplate.approvalRemind.header', { type: approvalTypeLabel.value })
)

function handleLink () {
  emits('closeDetails')
  const path = ApprovalPath[props.content.approval_type]
  path && router.push(path)
}

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(headerText.value), 1),
    _createVNode(_component_i18n_t, {
      keypath: "messageTemplate.approvalRemind.body",
      tag: "div",
      class: "cm-message-body"
    }, {
      applicant: _withCtx(() => [
        _createElementVNode("strong", null, _toDisplayString(__props.content.applicant_name), 1)
      ]),
      time: _withCtx(() => [
        _createElementVNode("strong", null, _toDisplayString(__props.content.application_time), 1)
      ]),
      type: _withCtx(() => [
        _createElementVNode("strong", null, _toDisplayString(applicationLabel.value), 1)
      ]),
      menu: _withCtx(() => [
        _createElementVNode("span", {
          class: "cm-link-light underline",
          onClick: handleLink
        }, _toDisplayString(menuName.value), 1)
      ]),
      _: 1
    })
  ]))
}
}

})